import { Link } from "react-router-dom";

const Title = ({ text, link }: { text: string, link?: string }) => {
  return (
      <Link to={link || ''}>
      <h1 className="text-primary font-extrabold text-3xl text-center py-5">
        {text}
      </h1>
      </Link>
  );
};

export default Title;
